define('widgets/dgrid/viewmodel',[
    'underscore',
    'knockout'
], function (_, ko) {
    /**
     * Usage:
     *
     *      <div data-bind="dgrid-widget"></div>
     *
     */

    var DGrid = function (valuablesBlock,
                          lastPlayedBlock,
                          curatedContentBlock,
                          RecommendedBlock,
                          reelRacesBlock,
                          trophiesBlock,
                          reelRacesBlockBig,
                          allGamesBlock,
                          Block
    ) {
        var self = this;

        self.recommendedBlock1 = new Block(new RecommendedBlock(0));
        self.recommendedBlock2 = new Block(new RecommendedBlock(1));
        self.allGamesBlock = new Block(allGamesBlock, null, false);
        self.lastPlayedBlock = new Block(lastPlayedBlock, self.recommendedBlock2, false);
        self.curatedContentBlock = new Block(curatedContentBlock, self.recommendedBlock1, true);
        self.reelRacesBlock = new Block(reelRacesBlock, self.recommendedBlock1, false);
        self.trophiesBlock = new Block(trophiesBlock, self.recommendedBlock1, false);
        self.reelRacesBlockBig = new Block(reelRacesBlockBig, null, true);
        self.valuablesBlock = new Block(valuablesBlock, self.recommendedBlock1, false);

        self.grid = ko.observableArray([
            self.valuablesBlock,
            self.allGamesBlock,
            self.reelRacesBlockBig,
            self.trophiesBlock,
            self.lastPlayedBlock
        ]);

    };

    return DGrid;
});

